var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{class:[_vm.btnClass],attrs:{"disabled":_vm.disabled || _vm.isTimeoutSet},on:{"click":_vm.evOnClick}},[_c('i',{class:['fas', 'mr-2', 'text-twenty', _vm.iconClass]}),_vm._v(" "+_vm._s(_vm.btnText)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }